import { createSlice } from '@reduxjs/toolkit';

import { SBAT_GROUP_FILTERS } from '@classCreation/data/sbatGroupFilters';

const initialState = {
  isModalOpen: false,
  primaryInstructors: { applied: '', current: '' },
  secondaryInstructors: { applied: '', current: '' },
  academyModules: { applied: null, current: null },
  academyTopics: { applied: null, current: null },
  superBatches: { applied: null, current: null },
  fromDate: { applied: null, current: null },
  toDate: { applied: null, current: null },
};

export const sbatGroupBulkUpdateFilter = createSlice({
  name: 'sbatGroupBulkUpdateFilter',
  initialState,
  reducers: {
    setSbatGroupBulkUpdateFilterModalState: (state, action) => {
      state.isModalOpen = action.payload;
    },
    setFilterValue: (state, action) => {
      const { type, key, value } = action.payload;
      state[key][type] = value;
    },
    applyCurrentFilter: (state, action) => {
      for (const key in SBAT_GROUP_FILTERS) {
        state[key].applied = state[key].current;
      }
      state.isModalOpen = false;
    },
    removeFilter: (state, action) => {
      state[action.payload] = initialState[action.payload];
    },
    resetFilters: (state) => {
      for (const key in SBAT_GROUP_FILTERS) {
        state[key] = initialState[key];
      }
    },
  },
});

export const {
  setSbatGroupBulkUpdateFilterModalState,
  setFilterValue,
  applyCurrentFilter,
  removeFilter,
  resetFilters,
} = sbatGroupBulkUpdateFilter.actions;

export default sbatGroupBulkUpdateFilter.reducer;
